import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AprovacaoPixService {

  constructor(
    private http: HttpService,
  ) { }

  aprovacaoPix(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/limite-pix/pedidos-aumento',data, successHandle, errorHandle);

  }

}
